/**
 * True when the value is a hex color that should be treated like white (e.g. lasertag team swatches from the API).
 */
export function isHexWhiteLike(color) {
  if (!color || typeof color !== 'string') return false;
  const n = color.trim().replace(/^#/, '').toLowerCase();
  return n === 'fff' || n === 'ffffff';
}
